import { render, staticRenderFns } from "./W9TaxForm.vue?vue&type=template&id=cc5b9d52&scoped=true&"
import script from "./W9TaxForm.vue?vue&type=script&lang=js&"
export * from "./W9TaxForm.vue?vue&type=script&lang=js&"
import style0 from "./W9TaxForm.vue?vue&type=style&index=0&id=cc5b9d52&scoped=true&lang=css&"
import style1 from "./W9TaxForm.vue?vue&type=style&index=1&id=cc5b9d52&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5b9d52",
  null
  
)

export default component.exports